exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-67cd56cc] {\n  padding:4px 24px 0px 24px;\n  font-weight:bold;\n}\n.btn-report[data-v-67cd56cc] {\n  color: #343a40;\n  border-color: #343a40 !important;\n}\n.btn-report[data-v-67cd56cc]:hover {\n  color: #343a40;\n  border-color: #343a40 !important;\n  background-color: #fff !important;\n}\n.disabled[data-v-67cd56cc] {\n  cursor: not-allowed;\n  color: gray\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-67cd56cc","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ReportDropdownList.vue
// module id = HmEk
// module chunks = 70